import Navbar from '@/pages/home/components/Navbar';
import Contact from '@/pages/home/components/Contact';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact Higher Standard Global',
  url: `${siteUrl}/contact`,
  description:
    'We accept new clients exclusively by referral or direct inquiry. If you are ready to discuss your property, we are ready to listen.',
  mainEntity: {
    '@type': 'RealEstateAgent',
    name: 'Higher Standard Global',
    url: siteUrl,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: 'English',
    },
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Contact', item: `${siteUrl}/contact` },
    ],
  },
};

export default function ContactPage() {
  useSEO({
    title: 'Contact | Higher Standard Global — Begin the Conversation',
    description:
      'We accept new clients exclusively by referral or direct inquiry. Contact Higher Standard Global to discuss premium property management for your residential or commercial property.',
    keywords: 'contact Higher Standard Global, property management inquiry, referral property management, premium real estate management contact',
    canonical: '/contact',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={contactSchema} id="schema-contact" />
      <Navbar />
      <PageHero
        eyebrow="Begin the Conversation"
        title="Contact"
        subtitle="We accept new clients exclusively by referral or direct inquiry. If you are ready to discuss your property, we are ready to listen."
        imageUrl="https://public.readdy.ai/ai/img_res/ef4e529a4b96ad608e7a3b3ef34f01c5.jpg"
      />
      <PageTransition label="Reach Out" />
      <Contact />
      <PageCrossLink
        prev={{
          label: 'Our Team',
          eyebrow: 'The Principals',
          description: 'Learn about the individuals behind Higher Standard Global.',
          path: '/team',
        }}
        next={{
          label: 'About Us',
          eyebrow: 'Higher Standard Global',
          description: 'Start from the beginning — who we are and what we stand for.',
          path: '/about',
        }}
      />
      <Footer />
    </main>
  );
}
